import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { PageHeader } from "@/components/common/Page";
import { Button } from "@/components/ui/button";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { TRAINING_GUIDE_MD } from "@/constants/trainingGuide";

export default function Help() {
  const [downloading, setDownloading] = useState(false);

  const downloadPdf = async () => {
    setDownloading(true);
    try {
      const res = await api.get("/help/training-guide/pdf", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "NavScora-Admin-Training-Guide.pdf";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Training guide downloaded");
    } catch (e) {
      toast.error("Could not generate PDF");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="ns-fade">
      <PageHeader
        title="Help & Training Guide"
        subtitle="A practical walkthrough of how each part of NavScora Admin works"
        testId="help-header"
      >
        <Button
          onClick={downloadPdf}
          disabled={downloading}
          className="bg-gradient-to-r from-cyan-500 to-sky-600 font-semibold text-slate-900 hover:from-cyan-400 hover:to-sky-500"
          data-testid="download-guide-pdf"
        >
          {downloading ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <Download className="mr-1.5 h-4 w-4" />}
          Download PDF
        </Button>
      </PageHeader>
      <div
        data-testid="training-guide-content"
        className="mx-auto max-w-4xl rounded-xl border border-[#1E2D4A] bg-[#0B1120] p-8"
      >
        <div className="ns-guide space-y-4 text-slate-300">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{TRAINING_GUIDE_MD}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
